import React, { useContext, useEffect } from "react";
import { FilterContext } from "../FilterContext";
import FilterPopup from "../FilterPopup";
import SelectableList from "../components/SelectableList";
import { initialNotificationStatusFilter } from "./FilterTypes/NotificationStatusFilterType";

interface NotificationStatusOption {
  label: string
  value: server.dto.NotificationStatusFilterSettings
};

const NotificationStatusFilter = () => {
  const title = RESX.Status.resxStatus;

  const options: NotificationStatusOption[] = [
    { label: RESX.Notifications.AllNotifications, value: "noFilter" },
    { label: RESX.Notifications.OnlyRead, value: "read" },
    { label: RESX.Notifications.OnlyUnread, value: "unread" }
  ];

  const { register, getValue, setInitialValue, setValue } = useContext(FilterContext);
  register("notificationStatus", {
    getTitle: () => title,
    renderSelection: (value) => <>{options.find(o => o.value === value.selectedNotificationStatus)?.label}</>,
    hasValue: (value) => value.selectedNotificationStatus !== "noFilter",
    reset: () => initialNotificationStatusFilter,
    areEqual: (a, b) => a.selectedNotificationStatus === b.selectedNotificationStatus
  });
  useEffect(() => {
    setInitialValue("notificationStatus", initialNotificationStatusFilter);
  }, []);

  const [selectedNotificationStatus, setSelectedNotificationStatus] = React.useState<NotificationStatusOption>(options.find(f => f.value === initialNotificationStatusFilter.selectedNotificationStatus));

  const [popupOpen, setPopupOpen] = React.useState<boolean>(false);

  const onChange = (option: NotificationStatusOption) => {
    let newSelectedOption: NotificationStatusOption;
    if (option.value === selectedNotificationStatus?.value) { newSelectedOption = undefined; } else { newSelectedOption = option; }

    setSelectedNotificationStatus(newSelectedOption);
    setPopupOpen(false);
    setValue("notificationStatus", {
      selectedNotificationStatus: newSelectedOption?.value
    });
  };

  const onPopupClose = () => {
    setPopupOpen(false);
  };

  const onPopupOpen = () => {
    setSelectedNotificationStatus(options.find(f => f.value === getValue("notificationStatus").selectedNotificationStatus));
    setPopupOpen(true);
  };

  const onApplyFilter = (e?) => {
    e?.preventDefault();
    setValue("notificationStatus", {
      selectedNotificationStatus: selectedNotificationStatus?.value
    });
    setPopupOpen(false);
  };

  return <div>
    <FilterPopup
      filterButtonLabel={title}
      content={<form onSubmit={onApplyFilter}>
        <SelectableList
          noSearch
          selectedItems={selectedNotificationStatus != null ? [selectedNotificationStatus] : []}
          items={options}
          onItemToggled={onChange}
          getId={p => p.value}
          getName={b => b.label}
        />
      </form>}
      open={popupOpen}
      onClose={onPopupClose}
      onOpen={onPopupOpen}
    />
  </div>;
};

export default NotificationStatusFilter;